import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SystemControlMode } from '../../interfaces/system-control-mode';
import { NgClass } from '@angular/common';
import { IconComponent } from '../../../../../shared/src/lib/components/icon/icon.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-control-state-toggle',
    templateUrl: './control-state-toggle.component.html',
    styleUrls: ['./control-state-toggle.component.scss'],
    imports: [
    NgClass,
    IconComponent,
    SelectButtonModule,
    FormsModule,
    TranslateModule
]
})
export class ControlStateToggleComponent implements OnInit {
  @Input() currentApplicationControlMode: SystemControlMode;

  controlOptions: any[];
  controlMode: SystemControlMode;
  @Output() public selectedApplicationControlMode = new EventEmitter<SystemControlMode>();
  public SystemControlMode = SystemControlMode;

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    this.controlOptions = [
      { name: this.translateService.instant('control-state-toggle.switch.auto'), value: SystemControlMode.Auto },
      { name: this.translateService.instant('control-state-toggle.switch.manual'), value: SystemControlMode.Manual },
    ];

    this.controlMode = this.currentApplicationControlMode;
  }
}
